import { Mic } from '@micdrop/web';
import { useEffect, useState } from 'react';

const volumeColor = '#00bb00';

export default function MicVolume() {
  const [volume, setVolume] = useState(0); // 0-100

  // Update volume
  useEffect(() => {
    const onVolumeChange = (volume: number) => {
      setVolume(Math.max(0, volume + 100));
    };
    Mic.on('Volume', onVolumeChange);
    return () => {
      Mic.off('Volume', onVolumeChange);
    };
  }, []);

  return (
    <div
      className="w-full h-4 rounded-md transition-all duration-100"
      style={{
        background: `linear-gradient(
              to right,
              ${volumeColor},
              ${volumeColor} ${volume}%,
              #ccc ${volume}%,
              #ccc 100%
            )`,
        width: '100%',
      }}
    />
  );
}
